var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","right-text":"","left-arrow":""},on:{"click-left":_vm.back}}),_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"address-info":_vm.addressInfo,"show-delete":"","show-set-default":""},on:{"save":_vm.onSave,"delete":_vm.onDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }